/* American Threads Co - turn long or named variant options into dropdowns,
   and keep the product gallery in step with what the shopper picks.

   PART 1 - DROPDOWNS
   An option becomes a dropdown when it has MIN_VALUES or more values (the
   Custom Baseball Jersey has 19 sizes) OR when its name is in FORCE_OPTIONS
   (Color and Skin Tone on the ugly sweaters: six values each, but six long
   pills still swamp the page).

   The theme's own markup is never touched: the real fieldset is hidden with a
   CSS :has() rule and the dropdown clicks the hidden radios. The dropdown is
   placed inside the add-to-cart form, above the personalisation block, which
   is the one spot that survives Horizon's re-render.

   PART 2 - GALLERY SYNC
   Picking a colour should show that colour; touching Skin Tone should show the
   skin tone guide. A variant carries only one featured image, so Shopify alone
   cannot do both.

   Slides are matched on the IMAGE ALT TEXT, not the file name, so renaming a
   file in Content > Files cannot break it. The convention is:
     - every colourway image's alt starts with the exact option value
       ("Navy Snowflake ugly Christmas sweater, front view")
     - the skin tone guide's alt contains "skin tone"
*/
(function () {
  var MIN_VALUES = 11;
  var SKIP_OPTIONS = ['design'];
  var FORCE_OPTIONS = ['color', 'colour', 'skin tone', 'skintone'];
  var SKIN_HINT = 'skin tone';
  var hidden = {};

  function baseStyle() {
    if (document.getElementById('atc-vsel-style')) return;
    var s = document.createElement('style');
    s.id = 'atc-vsel-style';
    s.textContent = [
      '.atc-vsel-wrap{margin:0 0 18px;}',
      '.atc-vsel-wrap > span{display:block;font-size:13px;letter-spacing:.02em;margin:0 0 6px;}',
      '.atc-vsel{display:block;width:100%;box-sizing:border-box;',
      'padding:12px 14px;border-radius:8px;border:1px solid rgba(255,255,255,.3);',
      'background:transparent;color:inherit;font:inherit;font-size:15px;',
      'line-height:1.2;cursor:pointer;}',
      '.atc-vsel:focus{outline:none;border-color:currentColor;}',
      '.atc-vsel option{color:#000;background:#fff;}',
      '@media (max-width:749px){.atc-vsel{font-size:16px;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function hideFieldset(optionName) {
    if (hidden[optionName]) return;
    hidden[optionName] = true;
    var s = document.createElement('style');
    s.setAttribute('data-atc-vsel-hide', optionName);
    s.textContent = 'fieldset.variant-option:has(input[data-option-name="' +
      optionName.replace(/"/g, '') + '"]){position:absolute!important;' +
      'width:1px!important;height:1px!important;overflow:hidden!important;' +
      'clip:rect(0 0 0 0)!important;margin:0!important;padding:0!important;' +
      'border:0!important;opacity:0!important;pointer-events:none!important;}';
    document.head.appendChild(s);
  }

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('.card, .product-card, product-card, .resource-list__item, .quick-add')) continue;
      return f;
    }
    return null;
  }

  function radios(optionName) {
    return [].slice.call(
      document.querySelectorAll('variant-picker input[type="radio"][data-option-name="' + optionName.replace(/"/g, '') + '"]')
    );
  }

  function available(r) { return r.getAttribute('aria-disabled') !== 'true'; }

  function signature(list) {
    return list.map(function (r) {
      return r.value + (r.checked ? '*' : '') + (available(r) ? '' : 'x');
    }).join('|');
  }

  /* ---------------- gallery sync ---------------- */

  function productSlideshow() {
    var all = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < all.length; i++) {
      if (all[i].closest('.card, .product-card, product-card, .resource-list__item, .quick-add')) continue;
      return all[i];
    }
    return null;
  }

  function currentIndex(sc) {
    var slides = sc.querySelectorAll('slideshow-slide');
    if (!slides.length) return -1;
    var track = sc.querySelector('slideshow-slides');
    var w = slides[0].getBoundingClientRect().width || 1;
    return track ? Math.round(track.scrollLeft / w) : 0;
  }

  function altAt(sc, i) {
    var slides = sc.querySelectorAll('slideshow-slide');
    if (!slides[i]) return '';
    var img = slides[i].querySelector('img');
    return img && img.alt ? img.alt.toLowerCase() : '';
  }

  function findAlt(sc, needle) {
    var slides = sc.querySelectorAll('slideshow-slide');
    for (var i = 0; i < slides.length; i++) {
      if (altAt(sc, i).indexOf(needle) !== -1) return i;
    }
    return -1;
  }

  /* Horizon REPLACES the whole <slideshow-component> after a variant change,
     so a one-shot timer is useless - the jump gets thrown away with the old
     element. Instead hold the target and keep nudging until the deadline. */
  var chase = null;

  function stopChase() { if (chase) { clearInterval(chase); chase = null; } }

  function chaseAlt(needle, ms) {
    stopChase();
    var deadline = Date.now() + (ms || 4000);
    var tick = function () {
      if (Date.now() > deadline) { stopChase(); return; }
      var sc = productSlideshow();
      if (!sc) return;
      var cur = currentIndex(sc);
      /* Already on target: do nothing, but KEEP chasing. Horizon re-renders
         the media about 900ms after a variant change and snaps back to the
         first slide, so stopping at the first match loses the jump. */
      if (cur >= 0 && altAt(sc, cur).indexOf(needle) !== -1) return;
      var idx = findAlt(sc, needle);
      if (idx < 0) return;
      var btns = sc.querySelectorAll('slideshow-controls button');
      if (btns && btns[idx]) { btns[idx].click(); return; }
      try { if (typeof sc.select === 'function') sc.select(idx); } catch (e) {}
    };
    chase = setInterval(tick, 220);
    setTimeout(tick, 60);
  }

  /* If the shopper takes the gallery over, get out of the way at once. */
  document.addEventListener('pointerdown', function (e) {
    if (e.target && e.target.closest && e.target.closest('slideshow-component')) stopChase();
  }, true);

  function syncGallery(optionName, value) {
    var n = String(optionName || '').toLowerCase();
    var needle = null;

    if (n.indexOf('skin') !== -1) {
      needle = SKIN_HINT;
    } else if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) {
      needle = String(value || '').toLowerCase();
    }
    if (!needle) return;
    chaseAlt(needle, 4000);
  }

  /* Buttons that were never converted still need to drive the gallery. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    if (!t.closest || !t.closest('variant-picker')) return;
    syncGallery(t.getAttribute('data-option-name'), t.value);
  }, true);

  /* ---------------- dropdown conversion ---------------- */

  function convert(fs) {
    var first = fs.querySelector('input[type="radio"]');
    if (!first) return;

    var optionName = first.getAttribute('data-option-name') || '';
    if (!optionName) return;

    var lower = optionName.toLowerCase();
    if (SKIP_OPTIONS.indexOf(lower) !== -1) return;

    var list = radios(optionName);
    var forced = FORCE_OPTIONS.indexOf(lower) !== -1;
    if (!forced && list.length < MIN_VALUES) return;
    if (list.length < 2) return;

    var form = mainForm();
    if (!form) return;

    baseStyle();
    hideFieldset(optionName);

    var wrap = form.querySelector('[data-atc-vsel="' + optionName + '"]');
    var sig = signature(list);

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'atc-vsel-wrap';
      wrap.setAttribute('data-atc-vsel', optionName);

      var lab = document.createElement('span');
      var legend = fs.querySelector('legend');
      lab.textContent = legend ? legend.textContent.trim() : optionName;
      wrap.appendChild(lab);

      var sel = document.createElement('select');
      sel.className = 'atc-vsel';
      sel.setAttribute('aria-label', lab.textContent);
      wrap.appendChild(sel);

      sel.addEventListener('change', function () {
        var want = this.value;
        if (!want) return;
        var all = radios(optionName);
        for (var i = 0; i < all.length; i++) {
          if (all[i].value === want && !all[i].checked) { all[i].click(); break; }
        }
        syncGallery(optionName, want);
      });

      var anchor = form.querySelector('[data-atc-ct]');
      if (!anchor) {
        var submit = form.querySelector('[type="submit"]');
        anchor = submit ? (submit.closest('.product-form-buttons, .product-form__buttons, buy-buttons-component') || submit) : null;
      }
      if (anchor && anchor.parentNode && form.contains(anchor)) {
        anchor.parentNode.insertBefore(wrap, anchor);
      } else {
        form.appendChild(wrap);
      }
    }

    if (wrap.getAttribute('data-atc-sig') === sig) return;

    var select = wrap.querySelector('select');
    var html = '';
    var checked = '';

    list.forEach(function (r) {
      if (!available(r)) return;
      if (r.checked) checked = r.value;
      html += '<option value=' + JSON.stringify(r.value) + '>' +
              r.value.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</option>';
    });

    if (!checked) {
      html = '<option value="" disabled selected>Choose a ' +
             (wrap.firstChild.textContent || 'size').toLowerCase() + '</option>' + html;
    }

    select.innerHTML = html;
    select.value = checked || '';
    wrap.setAttribute('data-atc-sig', sig);
  }

  function scan() {
    var sets = document.querySelectorAll('variant-picker fieldset.variant-option');
    for (var i = 0; i < sets.length; i++) {
      try { convert(sets[i]); } catch (e) {}
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['aria-disabled', 'checked']
  });
})();